import { jsx as _jsx } from "react/jsx-runtime";
import { IconSpriteContext, useIconSpriteContext } from '#pplx/frontend/icons/IconSpriteContext.js';
import { memo, useMemo } from 'react';
export const IconSpriteProvider = memo(function IconSpriteProvider({ children, src, version, defaultSize }) {
    const inherited = useIconSpriteContext();
    const ctx = useMemo(() => {
        return {
            src: src ?? inherited.src,
            version: version ?? inherited.version,
            defaultSize: defaultSize ?? inherited.defaultSize,
        };
    }, [inherited, version, defaultSize, src]);
    return _jsx(IconSpriteContext.Provider, { value: ctx, children: children });
});
//# sourceMappingURL=IconSpriteProvider.js.map